import * as React from 'react';
import { Table } from '../common';
import moment from 'moment';
import { ActionRequest } from '../../actions';
import { truncateCurrencyNumber, truncateNumber } from '../../utils';

interface Props {
    readonly styled: StyledProps;
}

export class OverviewReport extends React.PureComponent<Props> {
    render() {
        const { themeMode } = this.props.styled;
        return (
            <Table
                styled={this.props.styled}
                columns={[
                    {
                        title: 'Report',
                        field: 'title',
                        headerStyle: {
                            textTransform: 'uppercase',
                        },
                        cellStyle: {
                            fontWeight: 500,
                        }
                    },
                    { title: 'TODAY', field: 'today' },
                    { title: 'YESTERDAY', field: 'yesterday' },
                ]}
                options={{
                    selection: false,
                    paging: false,
                    emptyRowsWhenPaging: false,
                    search: false,
                    sorting: false,
                    draggable: false,
                    showTitle: false,
                    toolbar: false,
                    headerStyle: {
                        borderBottom: themeMode === 'light' ? `1px solid #e9ebee` : '1px solid #323337',
                    }
                }}
                data={this.getReports}
                cellStyle={{
                    padding: '16px 10px',
                    fontSize: 14,
                    borderBottom: 'none',
                    textAlign: 'center',
                }}
            />
        );
    }

    private getReports = async (query: any) => {
        const today = moment().startOf('day').valueOf();
        const yesterdayStart = moment().subtract(1, 'day').startOf('day').valueOf();
        const yesterdayEnd = moment().subtract(1, 'day').endOf('day').valueOf();
        const result = await ActionRequest.get<Entities.GetOverviewReportsResponse>(`titleConfig/getOverviewReports`, {
            today,
            yesterdayStart,
            yesterdayEnd,
        });

        if (!result) {
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }

        const data = [
            {
                title: 'Unique Users',
                today: truncateNumber(result.todayReport.uniqueUsers), yesterday: truncateNumber(result.yesterdayReport.uniqueUsers) },
            { title: 'New Users', today: truncateNumber(result.todayReport.newUsers), yesterday: truncateNumber(result.yesterdayReport.newUsers) },
            { title: 'Purchases', today: truncateCurrencyNumber(result.todayReport.purchases), yesterday: truncateCurrencyNumber(result.yesterdayReport.purchases) },
            { title: 'Spenders', today: truncateNumber(result.todayReport.spenders), yesterday: truncateNumber(result.yesterdayReport.spenders) },
            { title: 'ARPU', today: truncateCurrencyNumber(result.todayReport.arpu), yesterday: truncateCurrencyNumber(result.yesterdayReport.arpu) },
            { title: 'ARPPU', today: truncateCurrencyNumber(result.todayReport.arppu), yesterday: truncateCurrencyNumber(result.yesterdayReport.arppu) },
        ];
        return {
            data,
            page: 0,
            totalCount: 0,
        };
    };
}